<template>
	<!--<custom-scroll>-->
		<div class="active-object-panel">
			<isogd-doc-in-point-list v-if="searchResult.docs && searchResult.docs.length" :docs="searchResult.docs"></isogd-doc-in-point-list>
			<another-in-point v-if="searchResult.other" :other="searchResult.other"></another-in-point>
		</div>
	<!--</custom-scroll>-->
</template>
<script>
	import IsogdDocInPointList from "./IsogdDocInPointList";
	import AnotherInPoint from "./AnotherInPoint";

	export default {
		props: {
			searchResult: {
				type: Object,
				required: true
			}
		},		
		components: {
			IsogdDocInPointList,
			AnotherInPoint
		}			
	}
</script>